module.exports = __webpack_public_path__ + "img/DK24246361.3235c3e7.png";